import { Chip, Grid, Typography } from '@mui/material';
import { getHostEntityStatusCode, getStatusChipMeta } from '../helpers/utils';

export const RetailerStatusField = ({ label, retailer, translations }) => {
  const statusMeta = retailer
    ? getStatusChipMeta(getHostEntityStatusCode(retailer), translations)
    : null;

  if (!statusMeta?.label) {
    return null;
  }

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <Typography
        variant='caption'
        color='text.secondary'
        display='block'
        sx={{ mb: 0.25, textTransform: 'uppercase', letterSpacing: 0.4 }}
      >
        {label}
      </Typography>
      <Chip
        size='small'
        label={statusMeta.label}
        variant={statusMeta.chipVariant}
        sx={statusMeta.chipSx}
      />
    </Grid>
  );
};
